<ng-container *ngIf="!sheetLoading">
	<div class="date-blocks" *ngIf="timeCardsMap.size > 0">
		<div class="date-block" *ngFor="let timeCardEntry of timeCardsMap | keyvalue : returnZero">
			<div class="date-title">
				<span class="date-span">{{timeCardEntry.key | date:'EEE, MMM d'}}</span>
				<span class="duration-span">{{getDuration(timeCardEntry.key)}}</span>
			</div>
			<div class="cards-block">
				<div *ngFor="let timeCard of timeCardEntry.value" class="card-block"
					(click)="openSheetDialog(timeCard)">
					<div class="project-block">

						<div class="project-title">{{timeCard.job?.name}}</div>
						<div class="bottom-label">{{timeCard.job?.customer?.name}}</div>

						<ng-container *ngIf="timeCard.type === 'UNPAID_BREAK'">
							<div class="project-title">Lunch Break</div>
							<div class="bottom-label {{timeCard.type}}-break-title">
								<div class="blyamba">
									UNPAID BREAK
								</div>
							</div>
						</ng-container>

						<ng-container *ngIf="timeCard.type === 'PAID_BREAK'">
							<div class="project-title">Rest Break</div>
							<div class="bottom-label {{timeCard.type}}-break-title">
								<div class="blyamba">
									PAID BREAK
								</div>
							</div>
						</ng-container>

						<ng-container *ngIf="timeCard.type === 'VACATION'">
							<div class="project-title">Vacation</div>
							<div class="bottom-label {{timeCard.type}}-break-title">
								<div class="blyamba">
									VACATION
								</div>
							</div>
						</ng-container>
					</div>
					<div class="time-block">
						<div class="duration-block" *ngIf="timeCard.finishTime">
							{{getDurationTime(timeCard.duration)}}
						</div>
						<div class="bottom-block">
							<div>{{timeCard.startTime | date:'shortTime' }}</div>
							-
							<div *ngIf="timeCard.finishTime">{{timeCard.finishTime | date:'shortTime' }}</div>
							<div *ngIf="!timeCard.finishTime" class="now-span">Now</div>

						</div>
					</div>

				</div>
			</div>
		</div>
	</div>

	<div class="date-blocks no-cards" *ngIf="timeCardsMap.size === 0">
		No Timecards
	</div>

</ng-container>


<div class="spinner-box" *ngIf="sheetLoading">
	<mat-spinner class="spinner"></mat-spinner>
</div>